import * as React from "react";
import { Layout } from "../../layout";
import { Routes, Route, Navigate } from "react-router-dom";
import { ListAndInvite } from "./listAndInvite";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { UserDetailInitializer } from "./detailInitializer";

const UserRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<Navigate to={`-index`} />} />
        <Route path={`-index/*`} element={<ListAndInvite />} />
        <Route path={`:idOrEmail/*`} element={<UserDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default UserRoute;
